import axios, {
  AxiosError,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from "axios";

export const API_URL = process.env.REACT_APP_BACKEND_URL;

const apiConfig: AxiosRequestConfig = {
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
};
const loginURL = process.env.REACT_APP_LOGIN_URL ?? "";

let isRefreshing = false;
const failedRequestQueue: Array<{
  resolve: (value?: unknown) => void;
  reject: (error: unknown) => void;
}> = [];

const processQueue = (error?: unknown) => {
  failedRequestQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(undefined);
    }
  });
  failedRequestQueue.length = 0;
};

const refreshAuthToken = async () => {
  return instance.post(`/token/refresh`, null, { withCredentials: true });
};

const rejectInterceptor = async (error: AxiosError<{ message: string }>) => {
  const originalRequest = error.config as InternalAxiosRequestConfig & {
    _retry?: boolean;
  };
  const message = error.response?.data.message;
  const isRefreshRequest = originalRequest?.url?.endsWith("/token/refresh");
  if (
    error.response?.status === 401 &&
    !originalRequest?._retry &&
    !isRefreshRequest
  ) {
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedRequestQueue.push({ resolve, reject });
      }).then(() => instance(originalRequest));
    }
    originalRequest._retry = true;
    isRefreshing = true;
    try {
      await refreshAuthToken();
      processQueue();
      return instance(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError);
      window.location.href = loginURL;
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
  return Promise.reject(message ?? error);
};

const requestInterceptor = (config: InternalAxiosRequestConfig) => ({
  ...config,
  withCredentials: true,
});

const instance = axios.create(apiConfig);
instance.interceptors.response.use(undefined, rejectInterceptor);
instance.interceptors.request.use(requestInterceptor);

export default instance;
